// src/Pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="grid min-h-[60vh] place-items-center p-6">
      <div className="max-w-md rounded-2xl border border-neutral-200 bg-white p-8 text-center">
        <h1 className="text-xl font-semibold">Page not found</h1>
        <p className="mt-2 text-sm text-neutral-600">
          The page you’re looking for doesn’t exist.
        </p>
        <div className="mt-4 flex items-center justify-center gap-3">
          <Link
            to="/"
            className="rounded-full border border-neutral-300 px-4 py-2 text-sm hover:bg-neutral-50"
          >
            ← Home
          </Link>
          <Link
            to="/explore"
            className="rounded-full bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-[#B8860B]"
          >
            Explore spaces
          </Link>
        </div>
      </div>
    </main>
  );
}
